import React from "react";
import { LinkToAnalysisPage, LinkToTipJarPage } from "../../constants/navUrlConstants";
import "./NavBar.css";
import { AppContextType, HelpPageName } from "../../AppContext";

interface NavBarProps {}
interface NavBarState {
  /** The visibility is handled via CSS.  State was added later to programmatically close it. */
  isOpen: boolean;
}

class NavBar extends React.Component<NavBarProps, NavBarState> {
  declare context: React.ContextType<typeof AppContextType>;
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(props: NavBarProps) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  switchTab = (tabName: string) => {
    window.location.hash = tabName;
    this.setState({ isOpen: false });
  };
  showHelpPage = () => {
    this.context.dispatch({ type: "ShowHelpPage", payload: HelpPageName.Overview });
    this.setState({ isOpen: false });
  };
  handleOpenClose = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { isOpen } = this.state;
    return (
      <nav className="nav-bar">
        <ol>
          <li>
            <button onClick={() => this.switchTab(LinkToAnalysisPage)}>chordnoodler.com</button>
          </li>
        </ol>
        <label className="hamburger-menu-label" htmlFor="hamburger-menu-checkbox" tabIndex={0}>
          ☰
        </label>
        <input id="hamburger-menu-checkbox" type="checkbox" checked={isOpen} onChange={this.handleOpenClose} />
        <ol>
          {/* <li>
            <button onClick={() => this.switchTab(LinkToCreditsPage)}>Credits</button>
          </li> */}
          <li>
            <button onClick={() => this.switchTab(LinkToTipJarPage)}>Tip Jar</button>
          </li>
          <li>
            <button onClick={this.showHelpPage}>Help</button>
          </li>
        </ol>
      </nav>
    );
  }
}

NavBar.contextType = AppContextType;

export default NavBar;
